import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create a singleton client for the app
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;

